/**
 * @deprecated Use `SettingsTabShell` from `../common` instead. This chrome is
 * now a shared Settings design-system primitive (My Business, Commissions, …);
 * this module re-exports it under the historical name for existing imports.
 */
import SettingsTabShell, {
  SettingsTabShellProps,
} from "../common/SettingsTabShell";

export type StudioTabShellProps = SettingsTabShellProps;

export default SettingsTabShell;
